import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { SharedCommonModule } from '../../shared/shared-common.module';

// Main Components
import { MediaLibraryComponent } from '../../shared/partials/media-library/media-library.component';
import { MediaLibraryModalComponent } from '../../shared/partials/media-library/media-library-modal/media-library-modal.component';

// Upload Components
import { MediaLibraryUploadFormComponent } from '../../shared/partials/media-library/media-library-modal/media-library-upload-form/media-library-upload-form.component';
import { MediaLibraryUploadZoneComponent } from '../../shared/partials/media-library/media-library-upload-zone/media-library-upload-zone.component';
import { MediaLibraryCropperComponent } from '../../shared/partials/media-library/media-library-modal/media-library-upload-form/media-library-cropper/media-library-cropper.component';

// Display Components
import { MediaLibraryGridFileViewComponent } from '../../shared/partials/media-library/media-library-modal/media-library-grid-file-view/media-library-grid-file-view.component';
import { MediaLibraryViewOnlyComponent } from '../../shared/partials/media-library/media-library-view-only/media-library-view-only.component';
import { MediaLibraryViewInformativeItemComponent } from '../../shared/partials/media-library/media-library-view-informative-item/media-library-view-informative-item.component';
import { MediaLibraryPreviewComponent } from '../../shared/partials/media-library/media-library-preview/media-library-preview.component';
import { MediaLibraryChangeZoneComponent } from '../../shared/partials/media-library/media-library-change-zone/media-library-change-zone.component';

// UI Components
import { FileTypeIconComponent } from '../../shared/partials/media-library/file-type-icon/file-type-icon.component';
import { MediaLibraryStorageMeterComponent } from '../../shared/partials/media-library/media-library-modal/media-library-storage-meter/media-library-storage-meter.component';

// Video Components
import { VideoModalComponent } from '../../shared/partials/video-modal/video-modal.component';
import { VideourlOrMediaComponent } from '../../shared/partials/media-library/videourl-or-media/videourl-or-media.component';

const MEDIA_LIBRARY_COMPONENTS = [
  // Main
  MediaLibraryComponent,
  MediaLibraryModalComponent,

  // Upload
  MediaLibraryUploadFormComponent,
  MediaLibraryUploadZoneComponent,
  MediaLibraryCropperComponent,

  // Display
  MediaLibraryGridFileViewComponent,
  MediaLibraryViewOnlyComponent,
  MediaLibraryViewInformativeItemComponent,
  MediaLibraryPreviewComponent,
  MediaLibraryChangeZoneComponent,

  // UI
  FileTypeIconComponent,
  MediaLibraryStorageMeterComponent,

  // Video
  VideoModalComponent,
  VideourlOrMediaComponent,
];

/**
 * MediaLibraryModule
 *
 * Purpose: Contains all media library components for:
 * - File uploads and management
 * - Image cropping and editing
 * - File preview and display
 * - Video handling
 * - Storage management
 */
@NgModule({
  declarations: MEDIA_LIBRARY_COMPONENTS,
  imports: [
    SharedCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    ImageCropperComponent,
  ],
  exports: MEDIA_LIBRARY_COMPONENTS,
})
export class MediaLibraryModule {}
